import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Grid } from '@mui/material';
import StepLayout from '../../components/StepLayout/StepLayout';
import { useTunnelDispatch, useTunnelState } from '../../context/TunnelContext';
import { SIZES } from '../../utils/mockData';

export default function SizeSelection() {
  const navigate = useNavigate();
  const dispatch = useTunnelDispatch();
  const { currentShoe } = useTunnelState();

  useEffect(() => {
    if (!currentShoe.brand) {
      navigate('/nouvelle-demande/marque', { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function selectSize(size) {
    dispatch({ type: 'SET_SIZE', size });
    navigate('/nouvelle-demande/gomme');
  }

  return (
    <StepLayout title="Pointure">
      <Grid container spacing={2}>
        {SIZES.map((size) => (
          <Grid item xs={3} sm={2} md={1} key={size}>
            <Button
              fullWidth
              variant="outlined"
              size="large"
              onClick={() => selectSize(size)}
            >
              {size}
            </Button>
          </Grid>
        ))}
      </Grid>
    </StepLayout>
  );
}
